import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CaseDetailComponent } from '../case-detail.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-delete-document-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule
  ],
  templateUrl: './delete-document-dialog.component.html',
  styleUrl: './delete-document-dialog.component.scss'
})
export class DeleteDocumentDialogComponent {
constructor(
    private readonly dialogRef: MatDialogRef<CaseDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  submit() {
    this.dialogRef.close(true);
  }
  cancel() {
    this.dialogRef.close(false);
  }
}
